// extracted by mini-css-extract-plugin
module.exports = {"brand-lists":"BrandLists_brand-lists__WNBgT"};